module.exports = __webpack_public_path__ + "static/media/segmento.30db0579.jpg";